import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '&.review-footer': {
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    boxSizing: 'border-box',
  },
  '.review-footer': {
    '&__caption-wrapper': {
      color: COLORS.WHITE,
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: `${theme.space[4]} 0 ${theme.space[2]} 0`,
      order: 2,
      boxSizing: 'border-box',
      display: 'flex',
      [mediaquery.sm]: {
        margin: `${theme.space[4]} -2vw ${theme.space[2]} -2vw`,
        width: 'calc(100% + 3vw)',
      },
      [mediaquery.md]: {
        order: 1,
        margin: `${theme.space[2]} 0`,
        width: '100%',
        justifyContent: 'start',
        minWidth: 'auto',
      },
    },
    '&__button-wrapper': {
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '4px',
      marginBottom: `${theme.space[2]}`,
      marginTop: `${theme.space[2]}`,
      display: 'flex',
      order: 1,
      [mediaquery.md]: {
        order: 2,
        flexWrap: 'nowrap',
      },
    },
    '&__caption-text': {
      whiteSpace: 'break-spaces',
      marginBottom: 0,
      width: 'fit-content',
      maxWidth: '40%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      flex: '0 0 auto',
      [mediaquery.md]: {
        width: 'fit-content',
        maxWidth: 'none',
        overflow: 'visible',
        textOverflow: 'clip',
        flex: 'initial',
      },
    },
    '&__caption-text-modules': {
      whiteSpace: 'break-spaces',
      marginBottom: 0,
      marginLeft: 'auto',
      width: 'fit-content',
      [mediaquery.md]: {
        width: 'fit-content',
      },
    },
    '&__caption-text:first-of-type': {
      textAlign: 'left',
    },
    '&__caption-text:last-of-type': {
      textAlign: 'right',
    },
    '&__icon': {
      marginLeft: theme.space[4],
      [mediaquery.md]: {
        marginLeft: theme.space[3],
      },
    },
    '&__icon--hidden': {
      '& > *:first-child': {
        display: 'none !important',
      },
    },
    '&__approve-btn': {
      backgroundColor: COLORS.PRIMARY500,
      color: COLORS.WHITE,
      padding: '10px 20px',
      borderRadius: '6px',
      border: 'none',
      fontWeight: 600,
      fontSize: '16px',
      minWidth: '247px',
      width: 'fit-content',
      maxHeight: '42px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      cursor: 'pointer',
      order: 3,
      '&:hover': {
        backgroundColor: COLORS.PRIMARY600,
        cursor: 'pointer',
      },
      '&:disabled': {
        backgroundColor: COLORS.NEUTRAL300,
        color: COLORS.NEUTRAL600,
      },
      marginTop: theme.space[0],
      [mediaquery.md]: {
        marginTop: theme.space[1],
        order: 1,
      },
    },
    '&__revision-btn': {
      color: COLORS.NEUTRAL800,
      backgroundColor: COLORS.WHITE,
      borderRadius: '6px',
      position: 'relative',
      padding: '8px 6px',
      minWidth: '43px',
      width: 'fit-content',
      minHeight: '42px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      cursor: 'pointer',
      order: 2,
      '&.review-footer__revision-btn svg': {
        color: COLORS.NEUTRAL800,
        fill: COLORS.NEUTRAL800,
        width: '18px',
        height: '18px',
        display: 'block',
        margin: 'auto',
      },
      '&:hover': {
        backgroundColor: COLORS.NEUTRAL100,
        cursor: 'pointer',
      },
      '&.review-footer__revision-btn:hover svg': {
        color: COLORS.WHITE,
        fill: COLORS.NEUTRAL800,
      },
      '&--active': {
        '&.review-footer__revision-btn svg': {
          color: COLORS.PRIMARY500,
          fill: COLORS.PRIMARY500,
        },
      },
      marginTop: theme.space[4],
      [mediaquery.md]: {
        marginTop: theme.space[1],
        order: 3,
      },
    },
    '&__revision-badge': {
      position: 'absolute',
      top: -8,
      left: -3,
      background: COLORS.RED500,
      color: COLORS.WHITE,
      borderRadius: '50%',
      width: 18,
      height: 18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 11,
      fontWeight: 700,
    },
    '&__warning-btn': {
      color: COLORS.WHITE,
      backgroundColor: COLORS.RED200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '100px',
      padding: '8px 16px',
      position: 'relative',
      '&:hover': {
        backgroundColor: COLORS.RED500,
      },
    },
    '&__neutral-btn': {
      backgroundColor: COLORS.WHITE,
      color: COLORS.NEUTRAL800,
      padding: '12px 24px',
      height: '42px',
      fontSize: '16px',
      minWidth: '200px',
      width: 'fit-content',
      borderRadius: '6px',
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      cursor: 'pointer !important',
      order: 1,
      '&:hover': {
        color: COLORS.WHITE,
        backgroundColor: COLORS.NEUTRAL100,
        cursor: 'pointer !important',
      },
      marginTop: theme.space[4],
      [mediaquery.md]: {
        marginTop: theme.space[1],
        order: 2,
      },
    },
  },
});
